// @flow

import { client } from '@gandi/app-runner/client';
import { cartMiddleware } from '@gandi/cart';
import { routerConfigs } from '@gandi/redux-sharing';

import globals from './globals';
import reducers from './src/reducers';
import routes from './src/routes';

const middlewares = [cartMiddleware];

client({
  middlewares,
  routes,
  reducers,
  anonymousSupport: true,
  routerConfig: routerConfigs.client,
  globals,
});
